/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { i18NTranslationsRetrieve } from '../fn/translation/i-18-n-translations-retrieve';
import { I18NTranslationsRetrieve$Params } from '../fn/translation/i-18-n-translations-retrieve';

@Injectable({ providedIn: 'root' })
export class BackendApiTranslationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `i18NTranslationsRetrieve()` */
  static readonly I18NTranslationsRetrievePath = '/api/i18n/translations/';

  /**
   * Переводы.
   *
   * Возвращает словарь переводов для указанной локали.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `i18NTranslationsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NTranslationsRetrieve$Response(
    params: I18NTranslationsRetrieve$Params,
    context?: HttpContext,
  ): Observable<
    BakendHttpResponse<{
      [key: string]: any;
    }>
  > {
    return i18NTranslationsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Переводы.
   *
   * Возвращает словарь переводов для указанной локали.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `i18NTranslationsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  i18NTranslationsRetrieve(
    params: I18NTranslationsRetrieve$Params,
    context?: HttpContext,
  ): Observable<{
    [key: string]: any;
  }> {
    return this.i18NTranslationsRetrieve$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<{
            [key: string]: any;
          }>,
        ): {
          [key: string]: any;
        } => r.body,
      ),
    );
  }
}
